export const ALL_INSURANCE = "ALL_INSURANCE";
export const SINGLE_INSURANCE = "SINGLE_INSURANCE";
export const SET_INTENDED_URL = "SET_INTENDED_URL";
